import manager from '@mailobj-browser/front/js/contracts/manager.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import replaceWith from '@mailobj-browser/front/js/tree/replaceWith.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { modifiers } from '../styles.js'

const handlers = new WeakMap()
const selects = new WeakMap()
const tables = new WeakMap()

const onInput = object(listener, {
  type: input,
  passive,
  task: async (list, { target }) => {
    const filters = selects.get(list)

    if (!filters.includes(target)) {
      return
    }

    const { selectedIndex, selectedOptions } = target
    const option = selectedOptions[selectedIndex]
    const template = one('template', option)

    if (!template) {
      trigger(list, filters)

      return
    }

    const { content: optionTemplateContent, ownerDocument } = template
    const { body } = ownerDocument
    const selectTemplate = one('select', optionTemplateContent)
    const { dataset } = selectTemplate
    const { filterKey } = dataset
    const previousSelect = one(`select[data-filter-key="${filterKey}"]`, list)

    await manager.fragment(selectTemplate)
    replaceWith(previousSelect, selectTemplate)

    const select = await inserted(selectTemplate, body)
    const { content: selectContent } = one('template', select)
    const { value: selectOptionValue } = one('option', select)
    const selectField = closest(`.${modifiers.new_field.new_select}`, select)
    const { childElementCount } = one('ol, li', selectContent)

    if (childElementCount === 1 && selectOptionValue === 'all') {
      selectField.classList.add(modifiers.new_field.new_disabled)
      select.disabled = true
    } else {
      selectField.classList.remove(modifiers.new_field.new_disabled)
      select.disabled = false
    }

    update(list)
    trigger(list, filters)
  }
})

const trigger = (list, filters) => {
  const table = tables.get(list)
  const called = []

  for (const select of filters) {
    const handler = handlers.get(select)

    if (!called.includes(handler)) {
      called.push(handler)
      handler(table, selects.get(list))
    }
  }
}

const update = list => {
  const filters = all('[data-filter-key][data-filter-type]', list)

  selects.set(list, filters)

  return filters
}

export const handle = (select, handler) => {
  queueMicrotask(async () => {
    const { ownerDocument } = select
    const { body } = ownerDocument

    await inserted(select, body)

    const list = closest('[data-contract~="table.list"]', select)

    handlers.set(select, handler)
    update(list)
  })
}

export default list => {
  tables.set(list, one('table', list))
  update(list)
  onInput.listen(list)

  queueMicrotask(async () => {
    await removed(list)
    selects.delete(list)
    tables.delete(list)
  })
}
